import styled from "styled-components";

export const ErrorMessageContainer = styled.div`
    font-size: ${globalThis.config.fonts.sizes.xxsmall};
    color: ${globalThis.config.colors.red1};
    padding-left: 1.063rem;
    padding-top: 0.5rem;
    position: absolute;
`;
